export async function parseUserAgent(userAgent: string) {
    const parser = new (await import("ua-parser-js")).UAParser(userAgent);
    return {
        browser: `${parser.getBrowser().name || ""} ${parser.getBrowser().version || ""}`.trim() || "Unknown Browser",
        os: `${parser.getOS().name || ""} ${parser.getOS().version || ""}`.trim() || "Unknown OS",
    };
}
